module.exports = __webpack_public_path__ + "img/time.a242cfaa.svg";